module.exports = __webpack_public_path__ + "static/bane-symbol-SCAG-cd4a810c17246632c14047dc3d444bd9.webp";